import React, { useState, useEffect } from 'react';
import './App.css';
import { gapi } from 'gapi-script';

const CLIENT_ID = 'YOUR_CLIENT_ID.apps.googleusercontent.com'; // Replace with your client ID
const API_KEY = 'YOUR_API_KEY'; // Replace with your API key
const SCOPES = 'https://www.googleapis.com/auth/calendar.events';

const daysOfWeek = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];

const hours = Array.from({ length: 13 }, (_, i) => {
  const hour = i + 7;
  const ampm = hour < 12 ? 'AM' : 'PM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}:00 ${ampm}`;
});

export default function AdminHoursBlocker() {
  const [blocked, setBlocked] = useState({});
  const todayIdx = new Date().getDay();
  const [selectedDay, setSelectedDay] = useState(daysOfWeek[todayIdx]);

  useEffect(() => {
    const saved = localStorage.getItem('blockedHours');
    if (saved) setBlocked(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem('blockedHours', JSON.stringify(blocked));
  }, [blocked]);

  useEffect(() => {
    function start() {
      gapi.client.init({
        apiKey: "AIzaSyAXul7OuTlrQcRJbH00HxJc6bLnPsXfpi4",
        clientId: '560187263562-4kl655obrs4g74pq1u8198cg138s4ua3.apps.googleusercontent.com',
        scope: SCOPES,
        discoveryDocs: [
          'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
        ],
      });
    }
    gapi.load('client:auth2', start);
  }, []);

  const signIn = () => {
    gapi.auth2.getAuthInstance().signIn();
  };

  const createEvent = (date, hour) => {
    const start = new Date(date);
    start.setHours(hour, 0, 0, 0);
    const end = new Date(start);
    end.setHours(start.getHours() + 1);
    const event = {
      summary: 'Blocked (Chris Details)',
      start: { dateTime: start.toISOString() },
      end: { dateTime: end.toISOString() },
    };
    return gapi.client.calendar.events.insert({
      calendarId: 'primary',
      resource: event,
    });
  };

  const toggleBlock = (day, hour) => {
    setBlocked(prev => {
      const key = `${day}-${hour}`;
      const updated = { ...prev };
      if (updated[key]) {
        delete updated[key];
      } else {
        updated[key] = true;
      }
      return updated;
    });
  };

  const getHourKey = (hourIdx) => `${selectedDay}-${hourIdx + 7}:00`;

  // Add a button to sign in and a button to block all selected hours for the selected day
  return (
    <div className="admin-hours-blocker">
      <h2>Block Hours (Unavailable for Scheduling)</h2>
      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="weekday-select">Select Day:&nbsp;</label>
        <select
          id="weekday-select"
          value={selectedDay}
          onChange={e => setSelectedDay(e.target.value)}
        >
          {daysOfWeek.map(day => (
            <option key={day} value={day}>{day}</option>
          ))}
        </select>
      </div>
      <ul className="hours-list">
        {hours.map((hourLabel, i) => {
          const key = getHourKey(i);
          return (
            <li
              key={key}
              className={blocked[key] ? 'blocked-hour' : 'available-hour'}
              style={{ background: blocked[key] ? '#f66' : '#eee', cursor: 'pointer', margin: '4px 0', padding: '6px 12px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
              onClick={() => toggleBlock(selectedDay, `${i + 7}:00`)}
              title={blocked[key] ? 'Blocked' : 'Available'}
            >
              <span>{hourLabel}</span>
              <span>{blocked[key] ? 'Blocked' : 'Available'}</span>
            </li>
          );
        })}
      </ul>
      <button onClick={signIn} style={{marginBottom: 12}}>Sign in with Google</button>
      <button
        onClick={async () => {
          const today = new Date();
          const year = today.getFullYear();
          const month = today.getMonth();
          const day = today.getDate() + (daysOfWeek.indexOf(selectedDay) - today.getDay());
          const date = new Date(year, month, day);
          for (let i = 0; i < hours.length; i++) {
            const key = `${selectedDay}-${i + 7}:00`;
            if (blocked[key]) {
              await createEvent(date, i + 7);
            }
          }
          alert('Blocked hours sent to Google Calendar!');
        }}
        style={{marginBottom: 20, marginLeft: 8}}
      >
        Block selected hours in Google Calendar
      </button>
      <p style={{marginTop: 20}}>Click hours to block/unblock for the selected day. (Persistence enabled.)</p>
    </div>
  );
}
